module.exports = __webpack_public_path__ + "img/no-overlap.fdfc2a27.svg";